export const UNLOCK_CHOICE_DECISION_TIMEOUT_MS = 3000;
export const UNLOCK_CHOICE_LOADER_DELAY_MS = 300;
export const UNLOCK_CHOICE_EXPOSURE_FLUSH_TIMEOUT_MS = 1000;
export const UNLOCK_CHOICE_DECISION_TIMEOUT_MS = 3000;
export const UNLOCK_CHOICE_LOADER_DELAY_MS = 300;
export const UNLOCK_CHOICE_EXPOSURE_FLUSH_TIMEOUT_MS = 1000;
